var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWaitlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 139,
    rx: 16,
    fill: "url(#paint0_radial_656_10)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 138,
    height: 138,
    rx: 15.5,
    stroke: "url(#paint1_linear_656_10)",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6083 38.9553C71.4956 36.8794 81.658 38.6749 91.5558 39.7554L79.7037 49.7165C79.7037 49.7165 75.0463 48.7689 72.0391 48.8171C69.0605 48.8649 66.598 49.368 64.4992 49.9406C54.1911 52.753 48.0736 63.5413 50.8357 74.037C53.5977 84.5327 64.1934 90.7613 74.5016 87.949C91.2085 83.3908 91.345 63.2178 85.3105 66.2555L60.3633 79.2103L93.171 50.3598C93.171 50.3598 94.1917 51.2787 94.7642 51.947C95.4886 52.7927 96.397 54.2901 96.4059 54.3048L96.3994 54.3107C97.4733 56.3615 98.3373 58.5682 98.9534 60.9094C103.312 77.4719 93.6592 94.4964 77.3926 98.9344C61.1259 103.372 44.4052 93.543 40.0465 76.9805C35.6879 60.4179 45.3416 43.3932 61.6083 38.9553Z",
    fill: "white",
    fillOpacity: 0.95
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_656_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(85.068 -2.24194 0.137888 85.068 69.5 69.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_656_10",
    x1: 0.00000170324,
    y1: 10.9378,
    x2: 152.167,
    y2: 31.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWaitlist);
export default __webpack_public_path__ + "static/media/logo_waitlist.e67188353a1603a1fd31f7d25681df67.svg";
export { ForwardRef as ReactComponent };